import z from 'zod';
import { apiOpenAiPlatformProviderPresetValues } from '@api/@types';
export const tOpenAiPlatformModel = z.object({
    id: z.string(),
    modelName: z.string(),
    tokenLimit: z.number()
});
export const tAzureOpenAiPlatformModel = tOpenAiPlatformModel.extend({
    deploymentName: z
        .string({ invalid_type_error: 'Please specify a deployment name for each model' })
        .min(1, 'Please specify a deployment name for each model'),
    id: z.string(),
    modelName: z.string(),
    tokenLimit: z.number()
});
const tOpenAiCommonProperties = z.object({
    id: z.string().optional(),
    apiKey: z.string().min(5, 'API Key is required').nullable(),
    url: z.string().url('Endpoint must be a valid URL')
});
export const tOpenAiFormSchema = z.discriminatedUnion('preset', [
    tOpenAiCommonProperties.extend({
        preset: z.enum(apiOpenAiPlatformProviderPresetValues).extract(['OPENAI']),
        models: z.array(tOpenAiPlatformModel)
    }),
    tOpenAiCommonProperties.extend({
        preset: z.enum(apiOpenAiPlatformProviderPresetValues).extract(['AZURE']),
        models: z.array(tAzureOpenAiPlatformModel)
    })
]);
